import React, { useEffect, useState } from "react";
import Tabs from "./Components/Tabs";
import { Separator } from "Components/ui/separator";
import UseInnerWidth from "hooks/UseInnerWidth";
import CertificateCard from "./Components/CertificateCard";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "@clerk/clerk-react";
import { getAllCertificates } from "../../Redux/Certificates/CertificatesActions";
import { format } from "date-fns";

function Certificates() {
  const [selectedTab, setSelectedTab] = useState("All");
  const width = UseInnerWidth();

  const dispatch = useDispatch();

  const { getToken } = useAuth();

  useEffect(() => {
    console.log("test");
    dispatch(getAllCertificates({}, getToken));
  }, []);

  const { certificates, getCertificatesLoading } = useSelector(
    (state) => state.CertificatesReducer
  );

  const { user } = useSelector((state) => state.ProfileReducer);

  const predefinedCertificates = [
    "Bronze Trader",
    "Silver Trader",
    "Gold Trader",
    "Platinum Trader",
  ];

  const [rewardCertificates, setRewardCertificates] = useState([]);
  const [missingCertificates, setMissingCertificates] = useState([]);

  useEffect(() => {
    if (certificates?.MILESTONE) {
      setRewardCertificates(
        certificates?.MILESTONE?.map((item) => item?.Certificate?.name) || []
      );
    }
  }, [certificates]);
  useEffect(() => {
    if (rewardCertificates.length > 0) {
      setMissingCertificates(
        predefinedCertificates.filter(
          (name) => !rewardCertificates.includes(name)
        )
      );
    }
  }, [rewardCertificates]);

  return (
    <div>
      <h1 className="font-N_Bold text-3xl">Certificates</h1>
      <Tabs selected={selectedTab} setSelected={setSelectedTab} />
      <div className="flex flex-col gap-8 p-6 border border-border-darkNew rounded-lg mt-6 bg-background">
        <div
          className={`${
            selectedTab != "Funded Certificates" && selectedTab != "All"
              ? "hidden"
              : "block"
          }`}
        >
          <div className="font-N_Medium text-2xl">Funded Certificates</div>
          <Separator className="border border-border-darkNew my-4" />
          <div
            className={`grid gap-6 ${
              width > 1350
                ? "grid-cols-3"
                : width > 850
                ? "grid-cols-2"
                : "grid-cols-1"
            }`}
          >
            {certificates?.hasOwnProperty("FUNDED") ? (
              certificates["FUNDED"]?.map((item, index) => {
                return (
                  <CertificateCard
                    certificateName={"capital"}
                    found={true}
                    key={index}
                    userName={
                      item?.User?.firstName + " " + item?.User?.lastName
                    }
                    date={format(new Date(item.issueDate), "MMM dd, yyyy")}
                    amount={Number(item.balance).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 2,
                    })}
                    stage={item.challengeName}
                    link={
                      process.env.REACT_APP_LOCAL_API +
                      "/certificate/" +
                      item?.id
                    }
                    displayName={item?.Certificate?.name}
                  />
                );
              })
            ) : user?.firstName ? (
              <CertificateCard
                certificateName={"capital"}
                userName={user?.firstName + " " + user?.lastName}
                date="2025-09-01"
                amount={"200K"}
                stage={"1-Step Algo"}
                link={"https://app.onlyfundsfx.com"}
                found={false}
                displayName={"Certificate Of Capital Allocation"}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <div
          className={`${
            selectedTab != "Payout Certificates" && selectedTab != "All"
              ? "hidden"
              : "block"
          }`}
        >
          <div className="font-N_Medium text-2xl">Payout Certificates</div>
          <Separator className="border border-border-darkNew my-4" />
          <div
            className={`grid gap-6 ${
              width > 1350
                ? "grid-cols-3"
                : width > 850
                ? "grid-cols-2"
                : "grid-cols-1"
            }`}
          >
            {certificates?.hasOwnProperty("PAYOUT")
              ? certificates["PAYOUT"]?.map((item, index) => {
                  return (
                    <CertificateCard
                      key={index}
                      certificateName={"withdraw"}
                      userName={
                        item?.User?.firstName + " " + item?.User?.lastName
                      }
                      date={format(new Date(item.issueDate), "MMM dd, yyyy")}
                      amount={Number(item.amount).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}
                      stage={item.challengeName}
                      link={
                        process.env.REACT_APP_LOCAL_API +
                        "/certificate/" +
                        item?.id
                      }
                      found={true}
                      displayName={item?.Certificate?.name}
                    />
                  );
                })
              : user?.firstName && (
                  <CertificateCard
                    certificateName="withdraw"
                    userName={user?.firstName + " " + user?.lastName}
                    date="2025-09-01"
                    amount={"200K"}
                    stage={"1-Step Algo"}
                    link={"https://app.onlyfundsfx.com"}
                    found={false}
                    displayName={"Certificate of Withdrawal"}
                  />
                )}
          </div>
        </div>
        <div
          className={`${
            selectedTab != "Milestones" && selectedTab != "All"
              ? "hidden"
              : "block"
          }`}
        >
          <div className="font-N_Medium text-2xl">Milestone</div>
          <Separator className="border border-border-darkNew my-4" />
          <div
            className={`grid gap-6 ${
              width > 1350
                ? "grid-cols-3"
                : width > 850
                ? "grid-cols-2"
                : "grid-cols-1"
            }`}
          >
            {certificates?.hasOwnProperty("MILESTONE") ? (
              <>
                {certificates["MILESTONE"]?.map((item, index) => (
                  <CertificateCard
                    key={index}
                    certificateName={item?.Certificate?.name
                      ?.split(" ")[0]
                      ?.toLowerCase()}
                    userName={
                      item?.User?.firstName + " " + item?.User?.lastName
                    }
                    date={format(new Date(item.issueDate), "MMM dd, yyyy")}
                    amount={Number(item.balance).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 2,
                    })}
                    stage={item.challengeName}
                    link={
                      process.env.REACT_APP_LOCAL_API +
                      "/certificate/" +
                      item?.id
                    }
                    found={true}
                    displayName={item?.Certificate?.name}
                  />
                ))}
                {missingCertificates.length > 0 &&
                  missingCertificates.map(
                    (_, index) =>
                      user?.firstName && (
                        <CertificateCard
                          key={index}
                          certificateName={_.split(" ")[0].toLowerCase()}
                          userName={user?.firstName + " " + user?.lastName}
                          date="2025-09-01"
                          amount={"200K"}
                          stage={"1-Step Algo"}
                          link={"https://app.onlyfunds.com"}
                          found={false}
                          displayName={_}
                        />
                      )
                  )}
              </>
            ) : (
              <>
                {[
                  "Bronze Trader",
                  "Silver Trader",
                  "Gold Trader",
                  "Platinum Trader",
                ].map(
                  (_, index) =>
                    user?.firstName && (
                      <CertificateCard
                        key={index}
                        certificateName={_.split(" ")[0].toLowerCase()}
                        userName={user?.firstName + " " + user?.lastName}
                        date="2025-09-01"
                        amount={"200K"}
                        stage={"1-Step Algo"}
                        link={"https://app.onlyfunds.com"}
                        found={false}
                        displayName={_}
                      />
                    )
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Certificates;
